import _ from 'lodash';

// HyperTouch device helpers (API path: /gateways/eloview/devices).

export function hasDisplayValue(value) {
  return !_.isNil(value) && value !== '';
}

export function displayValue(value) {
  return hasDisplayValue(value) ? value : '—';
}

export function formatNetworkStringValue(value) {
  if (!hasDisplayValue(value)) return null;
  return String(value).replace(/^"+|"+$/g, '').trim();
}

export function parseExtraInfo(extraInfo) {
  if (_.isNil(extraInfo) || extraInfo === '') return {};
  if (_.isObject(extraInfo)) return extraInfo;
  try {
    return JSON.parse(extraInfo);
  } catch (error) {
    return {};
  }
}

export function getPlayingContentSummary(currentPlayingContent) {
  if (!currentPlayingContent || !_.isObject(currentPlayingContent)) {
    return { label: null, contentType: null };
  }

  const { applicationName, contentType, contentPlayingStatus } = currentPlayingContent;
  if (applicationName) {
    return { label: applicationName, contentType: contentType || null };
  }
  if (contentPlayingStatus && contentType) {
    return { label: contentType.toUpperCase(), contentType };
  }
  if (contentType) {
    return { label: null, contentType };
  }
  return { label: null, contentType: null, isIdle: true };
}

export function isIdlePlayingContent(content) {
  if (_.isNil(content) || (_.isObject(content) && _.isEmpty(content))) {
    return true;
  }

  const { contentType, contentPlayingStatus, applicationName, contentId, contentStatus, contentSource, statusTime, messageCode, scheduledId, extraInfo } = content;
  if (contentPlayingStatus || hasDisplayValue(applicationName) || hasDisplayValue(contentType) || hasDisplayValue(contentId)) {
    return false;
  }
  if (hasDisplayValue(contentStatus) || hasDisplayValue(contentSource) || statusTime || !_.isNil(messageCode) || hasDisplayValue(scheduledId)) {
    return false;
  }

  const { url, message, scheduled } = parseExtraInfo(extraInfo);
  return !hasDisplayValue(url)
    && !hasDisplayValue(message)
    && !hasDisplayValue(scheduled && scheduled.appName)
    && !hasDisplayValue(scheduled && scheduled.contentId);
}
